module.exports = __webpack_public_path__ + "static/media/game-boss.9cc7039c.png";